import {common_utils} from "../common/common_utils";

function game_5009()
{

}

game_5009.readDataValue = function(this1,data)
{
    this1.hasbonuswin = false
    this1.hasfree = false
    this1.mapList = []
    var mapJson = JSON.parse(data.detail.mapData)
    common_utils.readDataValue(this1,data);
    this1.winType1 = mapJson.winType1
    this1.winType2 = mapJson.winType2

    for (var i = 0; i < 2; i++)
    {
      for(var j = 0; j < 4; j++)
      {
        var item = mapJson.map[j]
        if(item.indexOf("_") > 0) {
          if (i == 0) {
            this1.mapList.push(item.substring(0, item.indexOf("_")) + "_B")
          } else {
            this1.mapList.push(item.substring(item.indexOf("_") + 1, item.length) + "_T");
          }
        } else {
          if (i == 0) {
            this1.mapList.push(item + "_T")
          } else {
            this1.mapList.push(item + "_B")
          }
        }
      }
    }
}
export {
  game_5009
};




// WEBPACK FOOTER //
// ./src/components/slots/game_5009.js